import CharacterCount from "@tiptap/extension-character-count";
import { Color } from "@tiptap/extension-color";
import Document from "@tiptap/extension-document";
import Image from "@tiptap/extension-image";
import Link from "@tiptap/extension-link";
import ListItem from "@tiptap/extension-list-item";
import Placeholder from "@tiptap/extension-placeholder";
import Table from "@tiptap/extension-table";
import TableCell from "@tiptap/extension-table-cell";
import TableHeader from "@tiptap/extension-table-header";
import TableRow from "@tiptap/extension-table-row";
import TextAlign from "@tiptap/extension-text-align";
import TextStyle from "@tiptap/extension-text-style";
import Underline from "@tiptap/extension-underline";
import StarterKit from "@tiptap/starter-kit";
import React from "react";
import {
  Highlight,
  KeywordHighlighter,
} from "./HighlighExtiensions/keyworHighlightExtension";
import MainEditor from "./MainEditor";
import "./Tiptap.scss";
import ConclusionZone from "./Zones/ConclusionZone/Extension";
import ContentZone from "./Zones/ContentZone/Extension";
import IntroZone from "./Zones/IntroZone/Extension";
import H1Zone from "./Zones/TopH1Zone/Extension";
import SpanMark from "./Zones/spanExtrension/Extenstion";

export const LIMIT = 20000000;

const CustomDocument = Document.extend({
  content: "h1zone introzone contentzone conclusionzone ",
});

export const extensions = [
  CustomDocument,
  Highlight,
  H1Zone,
  SpanMark,
  IntroZone,
  ContentZone,
  ConclusionZone,
  Image,
  KeywordHighlighter,
  Placeholder.configure({
    showOnlyWhenEditable: true,
    includeChildren: true,
    showOnlyCurrent: false,
    placeholder: ({ node }) => {
      return "";
    },
  }),

  Underline,
  Color.configure({ types: [TextStyle.name, ListItem.name] }),
  TextStyle.configure({ types: [ListItem.name] }),
  StarterKit.configure({
    document: false,
    bulletList: {
      keepMarks: true,
      keepAttributes: false, // TODO : Making this as `false` becase marks are not preserved when I try to preserve attrs, awaiting a bit of help
    },
    orderedList: {
      keepMarks: true,
      keepAttributes: false, // TODO : Making this as `false` becase marks are not preserved when I try to preserve attrs, awaiting a bit of help
    },
  }),
  TextAlign.configure({
    types: ["heading", "paragraph"],
    defaultAlignment: "left",
  }),
  Link.configure({
    openOnClick: false,
    autolink: true,
    HTMLAttributes: {
      rel: "noopener noreferrer",
    },
  }),
  Table.configure({
    resizable: true,
    allowTableNodeSelection: true,
  }),
  TableRow,
  TableHeader,
  TableCell,
  CharacterCount.configure({
    limit: LIMIT,
  }),
];

const content = ``;

export default () => {
  return (
    <div className="tiptap-container-editor">
      <MainEditor content={content} extensions={extensions} />
    </div>
  );
};
